import React from "react";

import "../../styles/components/numberBicho.scss";

import numberBichoData from "../../../utils/numberBichoData";

const ANIMATION_DURATION_IN_SECONDS = 0.25;
const DEFAULT_NUM_DIGITS = 4;

export default class NumberBicho extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     *  runAnimation: boolean
     * }}
     */
    this.state = {
      runAnimation: false,
    };

    this.select = this.select.bind(this);
  }
  bichoData(number){
    const bicho = numberBichoData.filter(bicho=>bicho.number===number.toString().padStart(2, "0"))[0]
    const data = {
      ...bicho,
      groupNumbers: new Array(4).fill().map((_, i) => ((4 * number + i - 3) % 100).toString().padStart(2, '0')).join(', ')
    }
    return data;
  }
  render() {
    /**
     * @type {{
     *  children: React.ReactNode,
     *  readonly: boolean,
     *  number: number,
     *  disabled: boolean,
     *  selected: boolean,
     *  showAnimal: boolean,
     *  hideCorrespondantNumbers?: boolean,
     * }}
     */
    const { children, readonly, number, numberLength, disabled, selected, showAnimal, hideCorrespondantNumbers, betAmount } =
      this.props;
    const { runAnimation } = this.state;
    
      // const groupNumbers = (groupNumber) => new Array(4).fill().map((_, i) => ((4 * groupNumber + i - 3) % 100).toString().padStart(2, '0'))

    return (
      <React.Fragment>
        <button
          onClick={this.select}
          data-amount={`x${betAmount}`}
          className={`number-bicho ${betAmount && betAmount > 1 ? "show-amount" : ""} ${
            runAnimation ? "number-bicho--select-animation" : ""
          } ${readonly ? "number-bicho--readonly" : ""} ${
            selected ? "number-bicho--selected" : ""
          } ${disabled ? "number-bicho--disabled" : ""}`}
          disabled={disabled}
        >
          <h3 className={`number-bicho-number ${showAnimal&&"with-image"}`}>
            {this.bichoData(number).number}
          </h3>
          {showAnimal && <img src={this.bichoData(number).image} className="number-bicho-image" />}
          <h6 className="number-bicho-name">{this.bichoData(number).name}</h6>
          {!hideCorrespondantNumbers && <p className="groupNumbers">{this.bichoData(number).groupNumbers}</p>}
        </button>
      </React.Fragment>
    );
  }

  select() {
    const { onClick, selected } = this.props;

    this.setState({
      ...this.state,
      runAnimation: !selected,
    });

    setTimeout(() => {
      this.setState({
        ...this.state,
        runAnimation: false,
      });
    }, ANIMATION_DURATION_IN_SECONDS * 1000);

    onClick();
  }
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/numberBicho.jsx